export const forEach = (arr, fn) => {
    if (!arr.length || !fn) return
    let i = -1
    let len = arr.length
    while (++i < len) {
      let item = arr[i]
      fn(item, i, arr)
    }
  }
  
  /**
   * @param {Array} arr1
   * @param {Array} arr2
   * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
   */
  export const getIntersection = (arr1, arr2) => {
    let len = Math.min(arr1.length, arr2.length)
    let i = -1
    let res = []
    while (++i < len) {
      const item = arr2[i]
      if (arr1.indexOf(item) > -1) res.push(item)
    }
    return res
  }
  
  /**
   * @param {Array} arr1
   * @param {Array} arr2
   * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
   */
  export const getUnion = (arr1, arr2) => {
    return Array.from(new Set([...arr1, ...arr2]))
  }

  /**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的差集
 */
 export const getIntersect = (arr1, arr2) => {
    var set1 = new Set(arr1)
    var set2 = new Set(arr2)
    var subset = []
    for (let item of set1) {
        if (!set2.has(item)) {
            subset.push(item)
        }
    }
    return subset
}

  
  /**
   * @param {Array} target 目标数组
   * @param {Array} arr 需要查询的数组
   * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
   */
  export const hasOneOf = (targetarr, arr) => {
    return targetarr.some(_ => arr.indexOf(_) > -1)
  }
  
  /**
   * @param {String|Number} value 要验证的字符串或数值
   * @param {*} validList 用来验证的列表
   */
  export function oneOf (value, validList) {
    for (let i = 0; i < validList.length; i++) {
      if (value === validList[i]) {
        return true
      }
    }
    return false
  }
  
  /**
   * @returns {String} 当前浏览器名称
   */
  export const getExplorer = () => {
    const ua = window.navigator.userAgent
    const isExplorer = (exp) => {
      return ua.indexOf(exp) > -1
    }
    if (isExplorer('MSIE')) return 'IE'
    else if (isExplorer('Firefox')) return 'Firefox'
    else if (isExplorer('Chrome')) return 'Chrome'
    else if (isExplorer('Opera')) return 'Opera'
    else if (isExplorer('Safari')) return 'Safari'
  }
  
  /**
   * @description 绑定事件 on(element, event, handler)
   */
  export const on = (function () {
    if (document.addEventListener) {
      return function (element, event, handler) {
        if (element && event && handler) {
          element.addEventListener(event, handler, false)
        }
      }
    } else {
      return function (element, event, handler) {
        if (element && event && handler) {
          element.attachEvent('on' + event, handler)
        }
      }
    }
  })()
  
  /**
   * @description 解绑事件 off(element, event, handler)
   */
  export const off = (function () {
    if (document.removeEventListener) {
      return function (element, event, handler) {
        if (element && event) {
          element.removeEventListener(event, handler, false)
        }
      }
    } else {
      return function (element, event, handler) {
        if (element && event) {
          element.detachEvent('on' + event, handler)
        }
      }
    }
  })()
  
  /**
   * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
   * 如果没有传入key这个参数，则判断obj对象是否有键值对
   */
  export const hasKey = (obj, key) => {
    if (key) return key in obj
    else {
      let keysArr = Object.keys(obj)
      return keysArr.length
    }
  }
  
  /**
   * @param {*} obj1 对象
   * @param {*} obj2 对象
   * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
   */
  export const objEqual = (obj1, obj2) => {
    const keysArr1 = Object.keys(obj1)
    const keysArr2 = Object.keys(obj2)
    if (keysArr1.length !== keysArr2.length) return false
    else if (keysArr1.length === 0 && keysArr2.length === 0) return true
    /* eslint-disable-next-line */
    else return !keysArr1.some(key => obj1[key] != obj2[key])
  }
  
  export const groupBy = (array, name) => {
    const groups = {}
    array.forEach(function (o) {
      const group = JSON.stringify(o[name])
      groups[group] = groups[group] || []
      groups[group].push(o)
    })
    return Object.keys(groups).map(function (group) {
      return groups[group]
    })
  }
  
  export const compare = (key, sort) => {
    return function (value1, value2) {
      var v1 = value1[key]
      var v2 = value2[key]
      if (sort === 'asc') {
        if (v1 < v2) {
          return -1
        } else if (v1 > v2) {
          return 1
        } else {
          return 0
        }
      } else {
        if (v1 > v2) {
          return -1
        } else if (v1 < v2) {
          return 1
        } else {
          return 0
        }
      }
    }
  }
  
  export const formatNumber = (value) => {
    return (Array(2).join(0) + value).slice(-2)
  }
  
  
  export const mumberFomat = (obj) => {
    if (typeof (obj) === 'string') obj = Number(obj)
    if (obj == null) obj = 0
    return obj.toFixed(0).replace(/(\d)(?=(\d{3})+\b)/g, '$1,')
  }
  
  export const moneyFomat = (obj) => {
    if (typeof (obj) === 'string') obj = Number(obj)
    if (obj == null) obj = 0
    return obj.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  }
  
  export const LatLng2Pixel = (latLng, scale, map) => {
      var proj = map.getProjection()
      var bounds = map.getBounds()
      var nw = proj.fromLatLngToPoint(new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getSouthWest().lng()))
      var point = proj.fromLatLngToPoint(latLng)
      return new google.maps.Point(Math.floor((point.x - nw.x) * scale), Math.floor((point.y - nw.y) * scale))
  }
  
  export const Pixel2LatLng = (pixel, scale, map) => {
      var proj = map.getProjection()
      var bounds = map.getBounds()
      var nw = proj.fromLatLngToPoint(new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getSouthWest().lng()))
      var point = new google.maps.Point()
      point.x = pixel.x / scale + nw.x
      point.y = pixel.y / scale + nw.y
      return proj.fromPointToLatLng(point)
  }
  
  export const actionsFixed = () => document.documentElement.clientWidth > 768 && document.documentElement.clientHeight > 576 ? 'right' : null
  
  const defaultTblHeight = 750
  export const tableHeight = (val) => {
    if (val) {
      const height = window.innerHeight - val - 62
      console.log(height)
      return height < 400 ? 400 : height
    }
    return defaultTblHeight
  }
  
  export const drawerConfig = () => {
    return {
      drawerWidth: document.documentElement.clientWidth > 860 ? 800 : 95,
      drawerLabelWidth: document.documentElement.clientWidth > 570 ? 158 : null,
      drawerLabelPosition: document.documentElement.clientWidth > 570 ? 'right' : 'top'
    }
  }
  